/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseHttpRequest } from './core/BaseHttpRequest';
import type { OpenAPIConfig } from './core/OpenAPI';
import { FetchHttpRequest } from './core/FetchHttpRequest';

import { AlchemyCompatibleExperimentalService } from './services/AlchemyCompatibleExperimentalService';
import { CenterApiInfoService } from './services/CenterApiInfoService';
import { CollectionAndAssetDataService } from './services/CollectionAndAssetDataService';
import { MarketDataService } from './services/MarketDataService';
import { NotificationStreamsService } from './services/NotificationStreamsService';
import { OrderbookDataExperimentalService } from './services/OrderbookDataExperimentalService';
import { OwnershipAndTransferDataService } from './services/OwnershipAndTransferDataService';
import { RenderingService } from './services/RenderingService';
import { SearchService } from './services/SearchService';

type HttpRequestConstructor = new (config: OpenAPIConfig) => BaseHttpRequest;

export class CenterClient {

    public readonly alchemyCompatibleExperimental: AlchemyCompatibleExperimentalService;
    public readonly centerApiInfo: CenterApiInfoService;
    public readonly collectionAndAssetData: CollectionAndAssetDataService;
    public readonly marketData: MarketDataService;
    public readonly notificationStreams: NotificationStreamsService;
    public readonly orderbookDataExperimental: OrderbookDataExperimentalService;
    public readonly ownershipAndTransferData: OwnershipAndTransferDataService;
    public readonly rendering: RenderingService;
    public readonly search: SearchService;

    public readonly request: BaseHttpRequest;

    constructor(config?: Partial<OpenAPIConfig>, HttpRequest: HttpRequestConstructor = FetchHttpRequest) {
        this.request = new HttpRequest({
            BASE: config?.BASE ?? 'https://api.center.dev',
            VERSION: config?.VERSION ?? '1.0.0',
            WITH_CREDENTIALS: config?.WITH_CREDENTIALS ?? false,
            CREDENTIALS: config?.CREDENTIALS ?? 'include',
            TOKEN: config?.TOKEN,
            USERNAME: config?.USERNAME,
            PASSWORD: config?.PASSWORD,
            HEADERS: config?.HEADERS,
            ENCODE_PATH: config?.ENCODE_PATH,
        });

        this.alchemyCompatibleExperimental = new AlchemyCompatibleExperimentalService(this.request);
        this.centerApiInfo = new CenterApiInfoService(this.request);
        this.collectionAndAssetData = new CollectionAndAssetDataService(this.request);
        this.marketData = new MarketDataService(this.request);
        this.notificationStreams = new NotificationStreamsService(this.request);
        this.orderbookDataExperimental = new OrderbookDataExperimentalService(this.request);
        this.ownershipAndTransferData = new OwnershipAndTransferDataService(this.request);
        this.rendering = new RenderingService(this.request);
        this.search = new SearchService(this.request);
    }
}
